import { render, staticRenderFns } from "./ExpertInfoDetailComponent.vue?vue&type=template&id=7061d0a6&scoped=true"
import script from "./ExpertInfoDetailComponent.vue?vue&type=script&lang=js"
export * from "./ExpertInfoDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./ExpertInfoDetailComponent.vue?vue&type=style&index=0&id=7061d0a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7061d0a6",
  null
  
)

export default component.exports